import { StepperFormConstants } from "./constants";

const defaultState = {
  loading: {
    isFormDraftLoading: false,
    isFormDraftSent: false
  },
  errors: undefined,
  showInfo: true,
  currentStep: 0,
  formDraft: {
    clientFullName: undefined,
    personData: undefined,
    finishedSteps: 0
  }
};

export const StepperFormReducer = (state = defaultState, action) => {
  switch (action.type) {
    case StepperFormConstants.GET_FORM_DRAFT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isFormDraftLoading: true
        }
      };
    case StepperFormConstants.GET_FORM_DRAFT_SUCCESS:
      return {
        ...state,
        formDraft: {
          clientFullName: action.payload.clientFullName,
          finishedSteps: action.payload.data.currentStep,
          personData: action.payload.data.personData
        },
        loading: {
          ...state.loading,
          isFormDraftLoading: false
        }
      };
    case StepperFormConstants.GET_FORM_DRAFT_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          isFormDraftLoading: false
        },
        errors: action.error
      };

    case StepperFormConstants.SAVE_FORM_DRAFT_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          isFormDraftSent: true
        }
      };
    case StepperFormConstants.SAVE_FORM_DRAFT_SUCCESS: {
      return {
        ...state,
        formDraft: {
          ...state.formDraft,
          finishedSteps: action.payload.data.currentStep,
          personData: action.payload.data.personData
        },
        loading: {
          ...state.loading,
          isFormDraftSent: false
        }
      };
    }
    case StepperFormConstants.SAVE_FORM_DRAFT_ERROR:
      return {
        ...state,
        loading: {
          ...state.loading,
          isFormDraftSent: false
        },
        errors: action.error
      };

    case StepperFormConstants.CLOSE_INFO_BUBBLE:
      return {
        ...state,
        showInfo: false
      };

    case StepperFormConstants.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };

    default:
      return state;
  }
};
